
<div class="border-round border-1 surface-borderp-2 surface-card">
    <div class="flex mb-3">
        <p-skeleton shape="circle" size="4rem" styleClass="mr-2 mb-2"></p-skeleton>
        <div>
            <p-skeleton width="10rem" styleClass="mb-2"></p-skeleton>
            <p-skeleton width="10rem" styleClass="mb-2"></p-skeleton>
            <p-skeleton styleClass="mb-2" width="80%"  height=".6rem"></p-skeleton>
            <p-skeleton styleClass="mb-2" width="80%" height=".6rem"></p-skeleton>

        </div>
    </div>

   
</div>



<div class="border-round border-1 surface-border p-2 surface-card">
  <div class="flex mb-3">
      <p-skeleton shape="circle" size="4rem" styleClass="mr-2 mb-2"></p-skeleton>
      <div>
          <p-skeleton width="10rem" styleClass="mb-2"></p-skeleton>
          <p-skeleton width="10rem" styleClass="mb-2"></p-skeleton>
          <p-skeleton styleClass="mb-2" width="80%" height=".6rem"></p-skeleton>
          <p-skeleton styleClass="mb-2" width="80%" height=".6rem"></p-skeleton>

      </div>
  </div>

 
</div>


<div class="border-round border-1 surface-border p-2 surface-card">
  <div class="flex mb-3">
      <p-skeleton shape="circle" size="4rem" styleClass="mr-2 mb-2"></p-skeleton>
      <div>
          <p-skeleton width="10rem" styleClass="mb-2"></p-skeleton>
          <p-skeleton width="10rem" styleClass="mb-2"></p-skeleton>
          <p-skeleton styleClass="mb-2" width="80%"  height=".6rem"></p-skeleton>
          <p-skeleton styleClass="mb-2" width="80%" height=".6rem"></p-skeleton>

      </div>
  </div>

 
</div>


<div class="border-round border-1 surface-border p-2 surface-card">
  <div class="flex mb-3">
      <p-skeleton shape="circle" size="4rem" styleClass="mr-2 mb-2"></p-skeleton>
      <div>
          <p-skeleton width="10rem" styleClass="mb-2"></p-skeleton>
          <p-skeleton width="10rem" styleClass="mb-2"></p-skeleton>
          <p-skeleton styleClass="mb-2"  width="80%"  height=".6rem"></p-skeleton>
          <p-skeleton styleClass="mb-2" width="80%" height=".6rem"></p-skeleton>

      </div>
  </div>

 
</div>



